import "./youtubeCard.scss"

function YoutubeCard({ source, header }) {
    return (
        <div className="aCard">
            <div className="aHead">
                <h2>{header}</h2>
            </div>
            <div className="aVideo">
                <iframe
                    src={`https://www.youtube.com/embed/${source}?si=o1cAXXWPrBO-_MA1`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                >
                </iframe>
            </div>
        </div>
    )
}

export default YoutubeCard